import { useLocalStore, useAsObservableSource } from 'mobx-react-lite';
import { useRef } from 'react';

import { useTranslation } from '@gem/modules/i18n';

import Tasks from 'APP/Tasks';
import { checkSlowMode } from 'APP/Tasks/messaging/checkSlowMode/checkSlowMode';
import { Features } from 'APP/packages/features/Features';

import { createScheduledArticle } from '../../Tasks/createScheduledArticle';
import { getArticlePayloadClass } from '../../Tasks/getArticlePayloadClass';
import { updateScheduledArticle } from '../../Tasks/updateScheduledArticle';

export default ({ parent }) => {
  const { t } = useTranslation();
  const publishButtonRef = useRef();
  const source = useAsObservableSource({ parent });

  const presenter = useLocalStore(() => ({
    isMenuOpen: false,

    get canOpenMenu() {
      if (!Features.isScheduledMessagesEnabled()) {
        return false;
      }

      return !presenter.isEditMode;
    },

    get isEditMode() {
      return source.parent.core.isEditMode;
    },

    get isShowMenu() {
      return !presenter.isEditMode && presenter.isMenuOpen;
    },

    get isDisabled() {
      return source.parent.core.isDisabled;
    },

    onCloseMenu() {
      presenter.isMenuOpen = false;
    },

    get title() {
      return presenter.isEditMode ? t('common_save') : t('channel_article_publish');
    },

    onToggleMenu() {
      presenter.isMenuOpen = !presenter.isMenuOpen;
    },

    onSend() {
      const canSend = checkSlowMode();
      if (!canSend.result) {
        canSend.error && Tasks.app.showToast(canSend.error);
        return;
      }

      source.parent.core.handleCreateArticle();
      source.parent.goBack();
    },

    onUpdate() {
      if (source.parent.core.message.isScheduled) {
        const data = source.parent.core.handleUpdateArticleData;
        updateScheduledArticle(data.groupId, data.messageId, getArticlePayloadClass(data));
        source.parent.goBack();
      } else {
        source.parent.core.handleUpdateArticle();
        source.parent.goBack();
      }
    },

    onScheduled() {
      const data = source.parent.core.handleCreateArticleData;
      createScheduledArticle(data.groupId, getArticlePayloadClass(data.payload));
    },

    onClick() {
      if (presenter.isEditMode) {
        presenter.onUpdate();
        return;
      }

      if (presenter.canOpenMenu) {
        presenter.onToggleMenu();
        return;
      }

      presenter.onSend();
    },
  }));

  return { presenter, publishButtonRef };
};
